import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';

const NotFound = lazy(() => import('../pages/NotFound'));
const Home = lazy(() => import('../pages/home/page'));
const Press = lazy(() => import('../pages/press/page'));
const PressDetail = lazy(() => import('../pages/press/detail'));
const PressAdmin = lazy(() => import('../pages/press/admin'));
const Chatbot = lazy(() => import('../pages/chatbot/page'));
const ChatbotAdmin = lazy(() => import('../pages/chatbot/admin'));
const Contact = lazy(() => import('../pages/contact/page'));
const Technology = lazy(() => import('../pages/technology/page'));
const AIAgent = lazy(() => import('../pages/technology/ai-agent'));
const AISWDeveloper = lazy(() => import('../pages/technology/ai-sw-developer'));
const AX = lazy(() => import('../pages/technology/ax'));
const AIDevPlatform = lazy(() => import('../pages/business/ai-dev-platform'));
const AIAgentPlatform = lazy(
  () => import('../pages/business/ai-agent-platform'),
);
const AXTransformation = lazy(
  () => import('../pages/business/ax-transformation'),
);
const SecurityService = lazy(
  () => import('../pages/business/security-service'),
);
const RecruitmentAdmin = lazy(() => import('../pages/recruitment/admin'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard'));

// Loading component
const Loading = () => (
  <div
    style={{
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
  </div>
);

// Helper to wrap components in Suspense
const withSuspense = (Component: React.ComponentType) => (
  <Suspense fallback={<Loading />}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(Home),
  },
  {
    path: '/press',
    element: withSuspense(Press),
  },
  {
    path: '/press/:slug',
    element: withSuspense(PressDetail),
  },
  {
    path: '/admin',
    element: withSuspense(AdminDashboard),
  },
  {
    path: '/admin/press',
    element: (
      <AdminLayout>
        <Suspense fallback={<Loading />}>
          <PressAdmin />
        </Suspense>
      </AdminLayout>
    ),
  },
  {
    path: '/admin/chatbot',
    element: (
      <AdminLayout>
        <Suspense fallback={<Loading />}>
          <ChatbotAdmin />
        </Suspense>
      </AdminLayout>
    ),
  },
  {
    path: '/admin/recruitment',
    element: (
      <AdminLayout>
        <Suspense fallback={<Loading />}>
          <RecruitmentAdmin />
        </Suspense>
      </AdminLayout>
    ),
  },
  {
    path: '/chatbot',
    element: withSuspense(Chatbot),
  },
  {
    path: '/contact',
    element: withSuspense(Contact),
  },
  {
    path: '/technology',
    element: withSuspense(Technology),
  },
  {
    path: '/technology/ai-sw-developer',
    element: withSuspense(AISWDeveloper),
  },
  {
    path: '/technology/ai-agent',
    element: withSuspense(AIAgent),
  },
  {
    path: '/technology/ax',
    element: withSuspense(AX),
  },
  {
    path: '/business/ai-dev-platform',
    element: withSuspense(AIDevPlatform),
  },
  {
    path: '/business/ai-agent-platform',
    element: withSuspense(AIAgentPlatform),
  },
  {
    path: '/business/ax-transformation',
    element: withSuspense(AXTransformation),
  },
  {
    path: '/business/security-service',
    element: withSuspense(SecurityService),
  },
  {
    path: '*',
    element: withSuspense(NotFound),
  },
];

export default routes;
